// extracted by mini-css-extract-plugin
export default {"container":"DiscoveryProgress_container__iIFAe","title":"DiscoveryProgress_title__eTKJA"};